<span class="{{ icon }}"></span>
